<template>
  <div>
    <template v-if="!hasUsers">
      <OnboardingComponent />
    </template>
    <div
      v-if="hasUsers"
      class="hero is-fullheight is-light"
    >
      <div
        class="
                hero-head
                is-flex is-flex-direction-column is-align-items-center
            "
      >
        <figure class="image mt-3">
          <img
            class="logo-color"
            :src="require('@/assets/logo/' + app_logo)"
          >
        </figure>
        <span class="version-pill">Version {{ shortVersion }}</span>
        <span
          v-if="testSystem"
          class="testsystem-badge"
        >⚠ Testsystem</span>
      </div>
      <div class="hero-body container">
        <div class="box login-accent">
          <p class="title is-4">
            Administrator
          </p>
          <b-field label="E-Mail">
            <b-input
              id="email"
              v-model="loginRequest.email"
              type="email"
              @input="$v.loginRequest.email.$touch"
              @keydown.native.enter="login"
            />
          </b-field>
          <b-field label="Passwort">
            <b-input
              id="password"
              v-model="loginRequest.password"
              type="password"
              password-reveal
              @input="$v.loginRequest.password.$touch"
              @keydown.native.enter="login"
            />
          </b-field>
          <b-button
            id="login"
            type="is-primary"
            :loading="isLoading"
            :disabled="$v.loginRequest.$invalid"
            expanded
            @click="login"
          >
            Anmelden
          </b-button>
          <b-button
            v-if="false"
            class="mt-2 is-small"
            style="
                            background-color: rgba(0, 0, 0, 0.4);
                            color: white;
                            border-radius: 0.25rem;
                        "
            :loading="isLoading"
            expanded
            @click="passwordResetModal"
          >
            Passwort vergessen?
          </b-button>
        </div>
      </div>
      <about-bar class="hero-foot" />
    </div>
    <PasswordResetModal />
  </div>
</template>

<script>
/**
 * This file allows login of admins (only admins can login in dashboard)
 */
import Parse from "parse/dist/parse.min.js";
import { required } from "vuelidate/lib/validators";
import email from "vuelidate/lib/validators/email";
import { negativeFeedBack, positiveFeedBack } from "@/lib/Toast";
import OnboardingComponent from "@/components/onboarding/OnboardingComponent";
import PasswordResetModal from "@/components/passwordReset/PasswordResetModal";
import AboutBar from "@/components/about/AboutBar";
import { APP_LOGO } from "@/lib/config/AppConfigurations";
import { isTestSystem } from "@/lib/isTestSystem";
import {
    trackLoginFailure,
    trackLoginDenied,
} from "@/lib/telemetry/telemetry";
import { version } from "../../../package.json";

export default {
    name: "LoginComponent",
    components: { PasswordResetModal, OnboardingComponent, AboutBar },
    data() {
        return {
            loginRequest: {
                email: "",
                password: "",
            },
            isLoading: false,
            admin: undefined,
            hasUsers: true,
			app_logo: APP_LOGO,
			shortVersion: version.split(".").slice(0, 2).join("."),
			testSystem: isTestSystem()
        };
    },
    validations: {
        loginRequest: {
            email: { required, email },
            password: { required },
        },
    },
    async mounted() {
		await this.checkUsers();
	},
	methods: {
		async checkUsers() {
			try {
				this.hasUsers = await Parse.Cloud.run("hasUsers");
				return;
			} catch (e) {
				console.error(e);
			}
			this.hasUsers = true;
		},
        async login() {
            this.isLoading = true;
            if (this.$v.loginRequest.email.$invalid)
                negativeFeedBack("Keine valide Email-Adresse");
            if (this.$v.loginRequest.password.$invalid)
                negativeFeedBack("Kein Passwort");
            if (
                !this.$v.loginRequest.email.$invalid &&
                !this.$v.loginRequest.password.$invalid
            ) {
                // password and email valid
                const params = { userName: this.loginRequest.email };
                const isUserAdmin = await Parse.Cloud.run("isAdmin", params);
                if (isUserAdmin) {
                    //authorization checked
                    await Parse.User.logIn(
                        this.loginRequest.email,
                        this.loginRequest.password
                    )
                        .then(() => {
                            positiveFeedBack("Nutzer angemeldet!");
                            window.location = "/";
                        })
                        .catch((err) => {
                            // Hashed account with a server-side pepper in the
                            // collector. Never awaited, never throws.
                            trackLoginFailure(this.loginRequest.email, err);
                            negativeFeedBack(
                                "Falsche Email-Adresse oder falsches Passwort!"
                            );
                            console.error(err);
                        });
                } else {
                    // Refused before any password check, so not a failed
                    // login and counted separately. Keyed on the hashed
                    // account: repeated probing of the admin app is what
                    // this exists to make visible.
                    trackLoginDenied(this.loginRequest.email, "not-admin");
                    negativeFeedBack("Sie haben keine Zugriffsberechtigung!");
                }
            }
            this.isLoading = false;
        },
        passwordResetModal() {
            this.$store.dispatch("setIsPasswordResetModalOpen", true);
        },
    },
};
</script>

<style lang="scss" scoped>
.version-pill {
    background-color: #2cbf7e;
    color: white;
    font-size: 0.72rem;
    font-weight: 700;
    padding: 0.22em 0.9em;
    border-radius: 999px;
    margin-top: 0.6rem;
}

.testsystem-badge {
    background-color: #f9c73e;
    color: #3b2f00;
    font-size: 0.95rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 0.35em 1.4em;
    border-radius: 6px;
    margin-top: 0.6rem;
}

/* Teal accent stripe: the visual marker of the 2.x login pages. */
.login-accent {
    border-top: 5px solid #1f8a8a;
    text-align: left;
}
</style>
